<template>
  <layout-report-step hasNext="false" :title="header.title" :description="header.description" :debug="report">
    <v-card flat max-width="500" class="pl-3 pr-3">
      <div class="pl-1 text" v-if="email"></div>
      <v-form ref="form" v-model="valid">
        <v-checkbox
          v-model="isReviewed"
          ref="reviewed"
          :rules="reportReviewedRules"
          :label="$t('report.summary.inputIsValid')"
          class="padded"
          data-test-review-checkbox
        ></v-checkbox>

        <v-checkbox
          :rules="[(v) => !!v || $t('report.summary.readPrivacy')]"
          v-model="isPrivacyChecked"
          ref="privacy"
          :label="$t('report.summary.privacyPolicyText')"
          class="padded"
          data-test-privacy-checkbox
        >
        </v-checkbox>

        <v-row class="justify-center align-center pt-8">
          <v-btn
            @click="submit"
            color="success"
            class="submitButton"
            rounded
            x-large
            :disabled="!isDone"
            :loading="isLoading"
            data-test-submit-button
          >
            <v-icon left> mdi-send </v-icon>
            {{ $t("report.summary.buttonTitle") }}
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { Component } from "vue-property-decorator";
import ReportSummary from "./ReportSummary.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportSummarySimple extends ReportSummary implements IReportStep {
  screen = ReportScreenEnum.closingsimple;
}
</script>

<style scoped>
.text {
  color: rgba(0, 0, 0, 0.6);
}
</style>
